import { useState, useRef, useEffect } from "react";

const MinusCircleIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="9" stroke="#98A2B3" strokeWidth="1.5" />
    <path d="M8 12H16" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9L12 15L18 9" stroke="#6941C6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function FilterDropdown({ label, value, options, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedLabel = options.find((o) => o.value === value)?.label ?? "All";

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 border border-[#D0D5DD] rounded-full px-4 py-2 text-sm whitespace-nowrap"
      >
        <MinusCircleIcon />
        <span className="text-[#344054]">{label}</span>
        <span className="text-[#6941C6] font-medium">{selectedLabel}</span>
        <ChevronDownIcon />
      </button>

      {open && (
        <div className="absolute left-0 mt-2 w-[180px] bg-white border border-[#EAECF0] rounded-lg shadow-lg z-10 py-1 max-h-[200px] overflow-y-auto">
          {options.map((opt) => (
            <button
              key={opt.value}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-gray-50 ${
                opt.value === value ? "text-[#6941C6] font-medium" : "text-[#344054]"
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}